// AutoGenerated
export class DizilimHesapModel {
    hesapId!: string;
    dizilimId!: string;
    locationX!: number;
    locationY!: number;
    id!: string;
    olusturan!: string;
    olusturmaTarih!: Date;
    guncelleyen!: string | null;
    guncellemeTarih!: Date | null;
}